import { connect } from 'react-redux';
import { getVisiblePanel } from '../../redux/selectors';
import { hidePanelPopup } from '../../redux/actions';
var mapStateToProps = function (state, _a) {
    var actionBarType = _a.actionBarType;
    return {
        visiblePanel: getVisiblePanel(state, actionBarType),
    };
};
var mapDispatchToProps = {
    onClose: hidePanelPopup,
};
export default connect(mapStateToProps, mapDispatchToProps);
//# sourceMappingURL=PanelPopup.container.js.map